/**
 * Created by Yu Zhang on 5/10/17.
 * Description:
 *
 * ------ maintenance history ------
*  ver1.1: modified by Alan Yang 7/19/17.
 *         added entityListReducer
 * ver1.2: modified by Alan Yang 8/7/17
 *         added getTemplateConfigEffect
 * ver1.3: modified by Marcus Zhao 6/14/19
 *         change some effects(belong to entity) for smartEffect
 * ver1.4: modified by Marcus Zhao 7/2/19
 *         Merge create/edit  entity effect as a Synchronous request
 */


import { of as observableOf, Observable, forkJoin, of } from 'rxjs';
import { catchError, switchMap, map, take } from 'rxjs/operators';
import { Action, Store } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { EntityService } from '@tamalelibs/services/entity.service';
import { GET_ENTITY_FIRST_PAGE_WITH_KEYWORD, GET_ENTITY_FIRST_PAGE_WITH_KEYWORD_FAILURE, GET_ENTITY_FIRST_PAGE_WITH_KEYWORD_SUCCESS } from '@tamalelibs/redux/thread-list.actions';
import { GET_ENTITY_NEXT_PAGE_WITH_KEYWORD, GET_ENTITY_NEXT_PAGE_WITH_KEYWORD_FAILURE, GET_ENTITY_NEXT_PAGE_WITH_KEYWORD_SUCCESS } from '@tamalelibs/redux/thread-list.actions';
import {
    GET_ENTITY, GET_ENTITY_SUCCESS, GET_ENTITY_FAILURE,
    GET_SLIDESHEET_ENTITY, GET_SLIDESHEET_ENTITY_SUCCESS,
    GET_SLIDESHEET_ENTITY_FAILURE, GET_SLIDESHEET_TEMPLATE_CONFIG_SUCCESS,
    GET_SLIDESHEET_TEMPLATE_CONFIG_FAILURE, GET_SLIDESHEET_TEMPLATE_CONFIG
} from '@tamalelibs/redux/app.actions';
import { Injectable } from '@angular/core';
import { GET_TEMPLATE_CONFIG, GET_TEMPLATE_CONFIG_SUCCESS, GET_TEMPLATE_CONFIG_FAILURE } from '@tamalelibs/redux/app.actions';
import { DefaultEntityTemplateConfigService } from '@tamalelibs/services/default-entity-template-config.service';
import { Entity } from '@tamalelibs/models/entity.model';
import { CREATE_ENTITY_SUCCESS, CREATE_ENTITY_FAILURE, CREATE_ENTITY, CREATE_EXTRAOROFFICE, CREATE_EXTRAOROFFICE_SUCCESS, CREATE_MEMBER, CREATE_MEMBER_SUCCESS, CREATE_MEMBER_FAILURE, CREATE_EXTRAOROFFICE_FAILURE, EDIT_ENTITY, EDIT_ENTITY_SUCCESS, EDIT_ENTITY_FAILURE } from '@tamalelibs/redux/entity.actions';
import { smartEffect } from '../../redux';
import { IAppState } from '@tamalelibs/redux/app.state';
import { EntityActionTypes } from '../actions/entity.actions';
import { EntityList } from '@tamalelibs/models/entity-list.model';

@Injectable()
export class EntityWebEffects {

    constructor(private _actions$: Actions, private _entityService: EntityService,
        private _store: Store<IAppState>) { }

    createEntityEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(CREATE_ENTITY),
        map(action => action as any),
        switchMap((action) => this._entityService.createEntity(action.payload.params).pipe(
            map(response => {
                const entity = Entity.parse(response);
                const createEntityResult = smartEffect(action, {
                    type: CREATE_ENTITY_SUCCESS,
                    payload: entity
                });
                action.payload.params.id = entity.id;
                const createEntiyArray: Array<Observable<any>> = [];
                createEntiyArray.push(
                    this._entityService.createTextraOrOfficer(action.payload.params).pipe(
                        map(() => {
                            return 'true';
                        }),
                        catchError(err => {
                            this._store.dispatch({ type: CREATE_EXTRAOROFFICE_FAILURE, payload: err });
                            return of(null);
                        }),
                        take(1),
                    ),
                );
                if (!action.payload.updateTopicMember) {
                    createEntiyArray.push(observableOf('true'));
                } else {
                    createEntiyArray.push(
                        this._entityService.createTopicmember(action.payload.params).pipe(
                            map(() => {
                                return 'true';
                            }),
                            catchError(err => {
                                this._store.dispatch({ type: CREATE_MEMBER_FAILURE, payload: err });
                                return of(null);
                            }),
                            take(1),
                        ),
                    );
                }
                forkJoin(createEntiyArray).subscribe((data) => {
                    if (data[0] === 'true' && data[1] === 'true') {
                        this._store.dispatch(createEntityResult);
                    } else {
                        const createEntityFailure = smartEffect(action, {
                            type: CREATE_ENTITY_FAILURE,
                            payload: ''
                        });
                        this._store.dispatch(createEntityFailure);
                    }
                });
                return { type: ' ', payload: '', };
            }),
            catchError(err => {
                const createEntityFailure = smartEffect(action, {
                    type: CREATE_ENTITY_FAILURE,
                    payload: err
                });
                return observableOf(createEntityFailure);
            }),
        )
        )));

    editEntityEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(EDIT_ENTITY),
        map(action => action as any),
        switchMap((action: any) => this._entityService.editEntity(action.payload.params, action.payload.updateTopicMember).pipe(
            map(response => {
                const entity = Entity.parse(response);
                const createEntityResult = smartEffect(action, {
                    type: EDIT_ENTITY_SUCCESS,
                    payload: entity
                });
                // add entity id for params
                action.payload.params.id = entity.id;
                this._store.dispatch(createEntityResult);
                return { type: ' ', payload: '', };
            }),
            catchError(err => {
                const createEntityFailure = smartEffect(action, {
                    type: EDIT_ENTITY_FAILURE,
                    payload: err
                });
                return observableOf(createEntityFailure);
            }),
        )
        )));

    createEntityExtraOrOfficerEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(CREATE_EXTRAOROFFICE),
        map(action => action as any),
        // map(action => action.payload),
        switchMap((action: any) => this._entityService.createTextraOrOfficer(action.payload.params).pipe(
            map(response => {
                // return ({
                //     type: CREATE_EXTRAOROFFICE_SUCCESS,
                //     payload: CREATE_EXTRAOROFFICE_SUCCESS
                // });
                return smartEffect(action, {
                    type: CREATE_EXTRAOROFFICE_SUCCESS,
                    payload: CREATE_EXTRAOROFFICE_SUCCESS
                });
            }),
            catchError(err => {
                return observableOf({ type: CREATE_EXTRAOROFFICE_FAILURE, payload: err });
            }))
        )));

    createEntityMermbersEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(CREATE_MEMBER),
        map(action => action as any),
        // map(action => action.payload),
        switchMap((action) => this._entityService.createTopicmember(action.payload.params).pipe(
            map(response => {
                // return ({
                //     type: CREATE_MEMBER_SUCCESS,
                //     payload: CREATE_MEMBER_SUCCESS
                // });
                return smartEffect(action, {
                    type: CREATE_MEMBER_SUCCESS,
                    payload: CREATE_MEMBER_SUCCESS
                });
            }),
            catchError(err => {
                return observableOf({ type: CREATE_MEMBER_FAILURE, payload: err });
            }))
        )));

    initializeEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(EntityActionTypes.INITIALIZE),
        map(action => action as any),
        switchMap(() => this._entityService.getAllEnities().pipe(
            map(response => {
                const result = [];
                response['entity-list'].forEach(element => {
                    result.push({ id: element.id, name: element['long-name'] });
                });
                return ({
                    type: EntityActionTypes.INITIALIZE_SUCCESS,
                    payload: result
                });
            }),
            catchError(err => {
                return observableOf({ type: EntityActionTypes.INITIALIZE_FAILED, payload: err.message });
            }))
        )));

    getEntityListFirstPageWithKeywordEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(GET_ENTITY_FIRST_PAGE_WITH_KEYWORD),
        map(action => action as any),
        map(action => action.payload),
        switchMap((payload) => this._entityService.getEntityList(payload.page, payload.pageSize, payload.keyword).pipe(
            map(response => {
                const entityList = this._entityService.mapEntityList(response);
                return ({
                    type: GET_ENTITY_FIRST_PAGE_WITH_KEYWORD_SUCCESS,
                    payload: entityList
                });
            }),
            catchError(err => {
                return observableOf({ type: GET_ENTITY_FIRST_PAGE_WITH_KEYWORD_FAILURE, payload: err.message });
            }))
        )));

    getEntityListNextPageWithKeywordEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(GET_ENTITY_NEXT_PAGE_WITH_KEYWORD),
        map(action => action as any),
        map(action => action.payload),
        switchMap((payload) => this._entityService.getEntityList(payload.page, payload.pageSize, payload.keyword).pipe(
            map(response => {
                const entityList = this._entityService.mapEntityList(response);
                return ({
                    type: GET_ENTITY_NEXT_PAGE_WITH_KEYWORD_SUCCESS,
                    payload: entityList
                });
            }),
            catchError(err => {
                return observableOf({ type: GET_ENTITY_NEXT_PAGE_WITH_KEYWORD_FAILURE, payload: err.message });
            }))
        )));

    getEntityEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(GET_ENTITY),
        map(action => action as any),
        map(action => action.payload),
        switchMap((payload) => this._entityService.getEntityDetail(payload.id).pipe(
            map(response => {
                const entity = Entity.parse(response, true);
                return ({
                    type: GET_ENTITY_SUCCESS,
                    payload: entity
                });
            }),
            catchError(err => {
                return observableOf({ type: GET_ENTITY_FAILURE, payload: err.message });
            }))
        )));

    getSideSheetEntityEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(GET_SLIDESHEET_ENTITY),
        map(action => action as any),
        map(action => action.payload),
        switchMap((payload) => this._entityService.getEntityDetail(payload.id).pipe(
            map(response => {
                const entity = Entity.parse(response, true);
                return ({
                    type: GET_SLIDESHEET_ENTITY_SUCCESS,
                    payload: entity
                });
            }),
            catchError(err => {
                return observableOf({ type: GET_SLIDESHEET_ENTITY_FAILURE, payload: err.message });
            }))
        )));

    getTemplateConfigEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(GET_TEMPLATE_CONFIG),
        map(action => action as any),
        // map(action => action.payload),
        switchMap((action) => this._entityService.getEntityTemplateConfig(action.payload.entityTypeId).pipe(
            map(response => {
                // return ({
                //     type: GET_TEMPLATE_CONFIG_SUCCESS,
                //     payload: response
                // });
                return smartEffect(action, {
                    type: GET_TEMPLATE_CONFIG_SUCCESS,
                    payload: response === null ? DefaultEntityTemplateConfigService.getDefaultEntityTemplateConfig() : response,
                });
            }),
            catchError(err => {
                // some entity doesn't have any custom adhoc tables and no template on server so set default template for it as TamaleNextgen does.
                return observableOf({
                    type: GET_TEMPLATE_CONFIG_FAILURE,
                    payload: DefaultEntityTemplateConfigService.getDefaultEntityTemplateConfig()
                });
            }))
        )));

    getSlideSheetTemplateConfigEffect$: Observable<Action> = createEffect(() => this._actions$.pipe(
        ofType(GET_SLIDESHEET_TEMPLATE_CONFIG),
        map(action => action as any),
        // map(action => action.payload),
        switchMap((action) => this._entityService.getEntityTemplateConfig(action.payload.entityTypeId).pipe(
            map(response => {
                return smartEffect(action, {
                    type: GET_SLIDESHEET_TEMPLATE_CONFIG_SUCCESS,
                    payload: response === null ? DefaultEntityTemplateConfigService.getDefaultEntityTemplateConfig() : response,
                });
            }),
            catchError(err => {
                // some entity doesn't have any custom adhoc tables and no template on server so set default template for it as TamaleNextgen does.
                return observableOf({
                    type: GET_SLIDESHEET_TEMPLATE_CONFIG_FAILURE,
                    payload: DefaultEntityTemplateConfigService.getDefaultEntityTemplateConfig()
                });
            }))
        )));
}
